export interface GoogleAnalyticsEventTrackerConfig {
    action?: string;
    category?: string;
    event: string;
    label?: string;
}

export default class GoogleAnalyticsEventTracker {
    readonly #globalConfig:
        | GoogleAnalyticsEventTrackerConfig
        | Record<string, string>;

    constructor(
        options?: GoogleAnalyticsEventTrackerConfig | Record<string, string>
    ) {
        this.#globalConfig = options || {};
    }

    trackEvent(
        config?: Partial<GoogleAnalyticsEventTrackerConfig>,
        customFields?: Record<string, string>
    ): void {
        const _config = { ...this.#globalConfig, ...config };

        if (
            _config?.event &&
            _config?.category &&
            _config?.action &&
            _config?.label
        ) {
            this.track({
                event: _config.event,
                eventCategory: _config.category,
                eventAction: _config.action,
                eventLabel: _config.label,
                ...customFields,
            });
        }
    }

    track(config = {}) {
        if (typeof window !== "undefined" && window.dataLayer) {
            window.dataLayer.push(config);
        }
    }
}

export const googleTrackerSingleton = new GoogleAnalyticsEventTracker();
